import DateAndTime from "../../Header/DateAndTime";
import TimeZone from "./TimeZone";

const Time: React.FC = () => {
  return (
    <div className="time">
      <DateAndTime></DateAndTime>
      <TimeZone></TimeZone>
    </div>
  );
};

export default Time;
